/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 *
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 */
export const pkgName = "@fluidframework/driver-base";
export const pkgVersion = "2.2.0";
//# sourceMappingURL=packageVersion.js.map